<template>
<div>
  <b-container fluid>
    <b-row class="row">
     <b-col class="mr-n5 px-n5" cols=1 v-if="showCard(1) == false">
        <b-icon class="h2 mb-2" icon="chevron-double-left" variant="secondary" @click="onHideExtraCard"/>
        <!-- backspace-reverse-fill box-arrow-right caret-left-fill-->
     </b-col>
     <b-col :lg="cols" class="col-xl-6" v-if="showCard(1) == true">
        <card>
          <TableActionHeader 
              ref="actionHeader" 
              v-on:filterChange="onInputChange" 
              v-on:newItem="onNewItem" 
              :newButton="$UIPrivilege('timetables', 'routes', 'create')"
              :selectOptions="lines"
              :selected="selectedLine"
              v-on:filterSelect="onLineSelected" 
              :selectListClearable="true" 
              :selectListSearchable="true" 
              selectListWidth="400px"
              :selectListPlaceholder="$t('route_view.line')">
          </TableActionHeader> 
          <RouteTable :filter="filter" v-on:selectItem="onSelectItem"></RouteTable>               
        </card>
      </b-col>
      <b-col class="col-xl-6">
        <InfoCard v-if="action == ''"></InfoCard>
        <card v-if="action == 'new'">
           <CardHeader :title="$t('item.new')"/>
             <RouteEdit :item="item" :action="action" ref="routeEdit" v-on:newItem="onItemUpdated" />
        </card>
        <card v-if="action == 'item' && item">
            <CardHeader :title="routeHeader" type="item"/>
            <tabs @activate-tab="onHideExtraCard">
              <tab-pane title="tab-1" key="tab-1">
                 <b-icon id="route-settings" slot="title" icon="gear" scale='1.1'></b-icon> 
                 <b-popover target="route-settings" triggers="hover" placement="top">
                   {{$t("timetable.tooltips.settings")}}
                 </b-popover>
                   <RouteEdit :item="item" :action="action" />
              </tab-pane>

              <tab-pane title="tab-2" key="tab-2" v-if="$UIPrivilege('timetables/routes', 'stops')">
                <b-icon id="route-stops" slot="title" icon="list-ol" scale='1.1'></b-icon> 
                <b-popover target="route-stops" triggers="hover" placement="top">
                  {{$t('timetable.tooltips.stops')}}
                </b-popover>
                  <RouteStops :item="item" ref="routeStops" v-on:updateItem="onItemUpdated" />
              </tab-pane>
                      
              <tab-pane title="tab-3" key="tab-3" v-if="$UIPrivilege('timetables/routes', 'destinations')">
                <b-icon id="route-destinations" slot="title" icon="card-list" scale='1.1'></b-icon> 
                <b-popover target="route-destinations" triggers="hover" placement="top">
                  {{$t('route_view.destinations')}}
                </b-popover>
                  <RouteDestinations :item="item" @showExtraCard="onShowRouteDestinations"/>
              </tab-pane>

              <tab-pane title="tab-4" key="tab-4" v-if="$UIPrivilege('timetables/routes', 'departures')">
                <b-icon id="route-departures" slot="title" icon="clock" scale='1.1'></b-icon> 
                <b-popover target="route-departures" triggers="hover" placement="top">
                  {{$t('departure.departure_times')}}
                </b-popover>
                  <RouteDepartures :item="item" @showExtraCard="onShowRouteDepartures" :departureUpdateTime="departureUpdateTime"
                    @hideExtraCard="onHideExtraCard"/>
              </tab-pane>
            </tabs>
          </card>
      </b-col>
      <b-col v-if="showCard(3) == true">
        <card v-if="cardName(3)== 'DestinationEdit'">
            <CardHeader :title="routeHeader" v-on:close="onHideExtraCard" close="true" hr="true"> </CardHeader>
            <DestinationEdit ref="destinationEditor"                    
                           :items="cardData(3).selectedDestinations" 
                           :action="cardData(3).formType" 
                           :stopName="cardData(3).stopName" 
                           :route="cardData(3).route" 
                         />
        </card>
        <card v-if="cardName(3) == 'PassingTimes'">
          <CardHeader :title="routeHeader" v-on:close="onHideExtraCard" close="true" hr="true"> </CardHeader>
          <PassingTimes ref="passingTimes" 
              :item="cardData(3).departure"
              :action="cardData(3).actionType" 
              :route="cardData(3).route"> 
          </PassingTimes> 
        </card>
        <card v-if="cardName(3) == 'DepartureEdit'">
              <CardHeader :title="$t('item.new')" v-on:close="onHideExtraCard" close="true" hr="true"> </CardHeader>
              <br/>
              <DepartureEdit ref="departureEditor" 
                :item="cardData(3).itemTemplate"
                :action="cardData(3).formType" 
                :route="cardData(3).route"
                @refreshDepartures="refreshDepartures"> 
              </DepartureEdit>  
              
         </card>
      </b-col>
     </b-row>
  </b-container>
</div>
</template>

<script>

const TableActionHeader = () => import('@/components/Misc/TableActionHeader')
const RouteTable = () => import('@/components/Timetable/RouteTable.vue')
const RouteEdit = () => import('@/components/Timetable/RouteEdit.vue')
const RouteDestinations = () => import('@/components/Timetable/RouteDestinations.vue')
const RouteStops = () => import('@/components/Timetable/RouteStops.vue')
const RouteDepartures = () => import('@/components/Timetable/RouteDepartures.vue')
const DestinationEdit = () => import('@/components/Timetable/DestinationEdit.vue')
const PassingTimes = () => import('@/components/Timetable/PassingTimes.vue')
const DepartureEdit = () => import('@/components/Timetable/DepartureEdit.vue')

import timetable from '@/store/timetable/timetable'
import utils from '@/plugins/TravellerUtils.js'
import moment from 'moment';
import card  from '@/store/ui/card'

const ExtraCards = Object.freeze({
  RouteDepartures : Symbol('routeDepartures'),
  RouteDestinations : Symbol('routeDestinations'),
  DepartureEdit : Symbol('departureEdit')
})

export default {
    name: 'Routes',
    components: {
        RouteTable, RouteDestinations, RouteEdit, RouteStops, RouteDepartures,
        TableActionHeader, DestinationEdit, PassingTimes, DepartureEdit
    },
    data: function() {
        return {
            showForm: true,
            cols: 8,
            filter: null,
            extraCard: null,
            item: {
                "tunnus": null,
                "nimi": null,
                    "destinations": {
                        "nimi" :null, 
                        "kautta" : null
                    },
            },
            tabIndex: 1,
            action: "",
            selectedLine: null,
            selectListClearable: true,
            destinationEditData: new Map(),
            passingTimesData: new Map(),
            departureEditData: null,
            ExtraCards,
            departureUpdateTime: null
        }
    },
    created() {
        if (!this.$store.state.timetable) {
            this.$store.registerModule("timetable" , timetable)
        }
        if( !this.$store.state.card ) {
            this.$store.registerModule('card' , card )
        }
        this.$store.commit('card/reset')
        this.$store.dispatch("timetable/getLinesListData")
    },
    computed: {
      lines() {
        if(!this.$store.state.timetable.lines.list)
          return ""
        return this.$store.state.timetable.lines.list.map((line) => {
          return {
            key: line.tunnus,
            label: line.tunnus + " - " + line.nimi,
            nimi: line.nimi,
            id: line.tunnus
          }}).sort((lineA, lineB) => {       
            return utils.alfaNumericCompare(lineA.key , lineB.key )
          })
      },
      routeHeader() {
        return this.item ? this.item.tunnus + " - " + this.item.nimi : ''; 
      },
      showCard() {
        return id => this.$store.getters['card/isCardVisible'](id)  
      },
      cardName() {
        return id => this.$store.getters['card/cardName'](id)
      },
      cardData() {
        return id => this.$store.getters['card/cardData'](id)
      }
    },
    mounted: function() {
      if(this.$route.query.routeId) {
        this.setFilterInput(this.$route.query.routeId);
        this.$refs.actionHeader.setFilterValue(this.filter.input);
      }
    },
    methods: {
        onInputChange: function(filter) {
          this.setFilterInput(filter);
        },
        onNewItem: function() {
            this.item = {};        
            this.action = "new"
        },
        onItemUpdated: function(item) {
            this.item = JSON.parse(JSON.stringify(item));                    
            this.action = "item"
        },
        onSelectItem: function(item) { 
            this.item = item ? JSON.parse(JSON.stringify(item)) : {};            
            this.action = item ? "item" : "";
        },
        onShowRouteDestinations: function(item) {
          this.destinationEditData = item.data
          this.extraCard = ExtraCards.RouteDestinations
        },
        onShowRouteDepartures: function(item) {
          if( item.card == "DepartureEdit" ) {
            this.departureEditData = item.data
            this.extraCard = ExtraCards.DepartureEdit
          } else {
            this.passingTimesData = item.data
            this.extraCard = ExtraCards.RouteDepartures
          }
        },
        refreshDepartures() {
          console.log("Routes refreshDepartures")
          this.departureUpdateTime = moment()
        },
        onHideExtraCard: function() {
          // this.extraCard = null
          this.$store.commit('card/reset')
        },
        onLineSelected: function(lineId){
          if(lineId == null)
            this.setFilterLine(null)
          else{
            this.setFilterLine(this.lines.find((el) => {
              return el.id == lineId
            }))
          }

        },
        setFilterInput(_input){
          let _line
          if(this.filter){
            _line = this.filter.line
          }else{
            _line = null
          }

          let newFilter = {
            line: _line,
            input: _input
          }
            
          this.filter = newFilter
        },
        setFilterLine(_line){
          let _input
          if(this.filter){
            _input = this.filter.input
          }else{
            _input = null
          }

          let newFilter = {
            line: _line,
            input: _input
          }
            
          this.filter = newFilter
        }
    }
}


</script>

<style>

</style>
